var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 3 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 20 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite",
    begin: "0.1s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 40 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 58 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite",
    begin: "0.5s"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 76 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite",
    begin: "0.1s"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    fill: "#4CAF50",
    width: 3,
    height: 100,
    transform: "translate(0) rotate(180 94 50)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    attributeType: "XML",
    dur: "1.8s",
    values: "30; 100; 30; 40; 50;",
    repeatCount: "indefinite",
    begin: "0.1s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading7);
export default __webpack_public_path__ + "static/media/loading-7.bd54dc715f1182bb3c20d4f07e8bbaa2.svg";
export { ForwardRef as ReactComponent };